module.exports = __webpack_public_path__ + "static/media/Group_395.77122c6d.svg";